import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/fileupload';
@Component({
  templateUrl: './fileupload.component.html'
})
export class FileuploadComponent implements OnInit {

  	code = Code;
	headers: any[];
	parameters: any[];
	eventHeader: any[];
	eventValue: any[];
  	styleHeader: any[];
	styleValue: any[];
	methodsHeader: any[];
	methodsValue: any[];

	msgs: any[];
    uploadedFiles: any[] = [];
    onUpload(event) {
        for(let file of event.files) {
            this.uploadedFiles.push(file);
        }
    
        this.msgs = [];
        this.msgs.push({severity: 'info', summary: 'File Uploaded', detail: ''});
    }
    constructor() {
        
    }

    ngOnInit() {
    	this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];
	    this.parameters = [
	        {name: "name",type: "string",default: "null",des: "用于标识后端文件的请求参数的名称。"},
	        {name: "url",type: "string",default: "null	",des: "远程URL上传文件。"},
	        {name: "method",type: "string",default: "POST",des: "HTTP方法将文件发送到URL。"},
	        {name: "multiple",type: "boolean",default: "false",des: "用于从文件对话框中同时选择多个文件。"},
	        {name: "accept",type: "string",default: "false",des: "模式来限制允许的文件类型，例如'image/*'。"},
	        {name: "disabled",type: "boolean",default: "false",des: "禁用上传功能。"},
	        {name: "auto",type: "boolean",default: "false ",des: "启用后，上传在选择完成后自动开始。"},
	        {name: "maxFileSize",type: "number",default: "null",des: "允许字节大小的最大文件大小。"},
	        {name: "invalidFileSizeMessageSummary",type: "string",default: "无效的文件大小：{ 0 }",des: "无效的FIZE大小的摘要消息。"},
	        {name: "invalidFileSizeMessageDetail",type: "string",default: "最大上传大小为{ 0 }",des: "无效的FIZE大小的详细信息。"},
	        {name: "invalidFileTypeMessageSummary",type: "string",default: "{ 0 }：无效的文件类型",des: "无效的FIZE类型的摘要消息。"},
	        {name: "invalidFileTypeMessageDetail",type: "string",default: "允许的文件类型：{ 0 }",des: "无效的FIZE类型的详细信息。"},
	        {name: "style",type: "string",default: "null",des: "组件行内样式。"},
	        {name: "styleClass",type: "string",default: "null",des: "组件的样式类。"},
	        {name: "previewWidth",type: "number",default: "50",des: "图像缩略图的宽度为像素。"},
	        {name: "chooseLabel",type: "string",default: "Choose ",des: "选择按钮的标签。"},
	        {name: "uploadLabel",type: "string",default: "Upload",des: "标签的上传按钮。"},
	        {name: "cancelLabel",type: "string",default: "Cancel",des: "标签的取消按钮。"},
	        {name: "withCredentials",type: "boolean",default: "false",des: "跨站点访问控制请求应使用Cookie、授权标头或TLS客户端证书等凭据进行。"},
	        {name: "mode",type: "string",default: "advanced",des: "定义组件的UI，可能的值是'高级'和'基本'。"},
	        {name: "customUpload",type: "boolean",default: "false",des: "是否使用默认上载或在上载处理程序回调中定义的手动实现。"},
	        {name: "showUploadButton",type: "boolean",default: "true",des: "定义客户端FieluPoad上传按钮的可见性。"},
	        {name: "showCancelButton",type: "boolean",default: "true",des: "定义客户端取消按钮的可见性。"},
	        {name: "files",type: "array",default: "null",des: "外部提供文件文件的列表。"}
	    ];

	    this.eventHeader = [
	    	{name:"名字"},
	    	{name:"参数"},
	    	{name:"描述"}
	    ]

	    this.eventValue = [
	    	{name: "onBeforeUpload",param: "1.event.xhr：XMLHttpRequest实例。 2.FaveDATA：FormDATA对象。",event: "在文件上传之前调用回调开始自定义请求，例如文件之前的POST参数。"},
	    	{name: "onBeforeSend",param: "1.event.xhr：XMLHttpRequest实例。 2.FaveDATA：FormDATA对象。",event: "在文件发送之前回调到调用开始定制请求，例如添加头文件。"},

	    	{name: "onUpload",param: "1.event.xhr：XMLHttpRequest实例。 2.事件文件：上传文件。",event: "文件上传完成后调用回调。"},
	    	{name: "onError",param: "1.event.xhr：XMLHttpRequest实例。 2.事件文件：未上载的文件。",event: "如果文件上传失败，则调用回调。"},
	    	{name: "onClear",param: "-",event: "取消队列中文件的调用，而不使用“清除所有”按钮上载。"},
	    	{name: "onRemove",param: "1.event.originalevent：原浏览器事件。 2.event.file：选定的文件。",event: "当一个文件被移除而不使用文件的“清除”按钮上载时调用回调。"},
	    	{name: "onSelect",param: "1.event.originalevent：原浏览器事件。 2.文件：选定文件的列表。",event: "在选择文件时调用回调。"},
	    	{name: "onProgress",param: "1.event.originalevent：原浏览器事件。 2.进展：计算进度值。",event: "在选择文件时调用回调。"},
	    	{name: "uploadHandler",param: "文件：选定文件的列表。",event: "回调以自定义上传模式调用以手动上传文件。"}
	    ]

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-fileupload",el :"容器元素。" },
	    	{name : "ui-fileupload-buttonbar",el :"包含按钮的标题。" },
	    	{name : "ui-fileupload-content",el :"内容部分。" }
	    ];

	    this.methodsHeader = [
	    	{name : "名字" },
	    	{name : "参数" },
	    	{name : "描述" }
	    ]
	    this.methodsValue = [
	    	{name: "upload",param: "-",event: "上载所选文件。"},
	    	{name: "clear",param: "-",event: "清除文件列表。"}
	    ]
    }

}



// WEBPACK FOOTER //
// ./src/app/view/fileupload/fileupload.component.ts